import * as schema from 'yup'

export default schema
